document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.star-rating').forEach(container => {
    const rating = parseFloat(container.dataset.rating) || 0;

    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('div');
      star.className = 'star';

      const inner = document.createElement('div');
      inner.className = 'star-inner';

      const fill = Math.max(0, Math.min(1, rating - (i - 1))) * 100;
      inner.style.width = fill + '%';

      star.appendChild(inner);
      container.appendChild(star);
    }
  });

  const testimonialSwiper = document.querySelector('.js-testimonial-swiper');

  if (testimonialSwiper) {
    const swiper = new Swiper('.js-testimonial-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      loopedSlides: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  const featuredTeamSwiper = document.querySelector('.js-featured-team-swiper');

  if (featuredTeamSwiper) {
    const swiper = new Swiper('.js-featured-team-swiper', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 1000,
    });
  }

  const backToTopBtn = document.querySelector('.back-to-top');
  const header = document.querySelector('.header-wrapper');
  const scrollClass = 'scrolled';

  window.addEventListener('scroll', () => {
    if (window.scrollY > 150) {
      backToTopBtn.classList.add('show');
      header.classList.add(scrollClass);
    } else {
      backToTopBtn.classList.remove('show');
      header.classList.remove(scrollClass);
    }
  });

  // Smooth scroll to top
  backToTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

});